import { Component, OnInit, Input, Inject, EventEmitter, Output, Injectable } from '@angular/core';
import { Location, CurrencyPipe, DatePipe } from '@angular/common';
import { FormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { RateBucketDetail } from '../rate-bucket-detail';
import { PercentageValuesPositive, PercentageValuesNegative, PercentageValuesPositiveAndNegative } from '../../../_helpers/constants';
import { RateManagerService } from '../rate-manager';
import { RateBucketDetailFormComponent } from '../rate-bucket-detail/rate-bucket-detail-form/rate-bucket-detail-form.component';
import { DialogData } from '@app/_components';


@Component({
    selector: 'app-rate-los',
    templateUrl: './rate-los.component.html',
    styleUrls: ['./rate-los.component.css'],
    providers: [MessageService],
    standalone: false
})

export class RateLosComponent implements OnInit
{

  constructor(
    private alertService: AlertService,
    private messageService: MessageService,
    private rateManagerService: RateManagerService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any)
  {
    this.formTitle = data.title,
      this.startDate = data.startDate,
      this.endDate = data.endDate,
      this.numNights = data.numNights,
      this.shortTermRentalId = data.shortTermRentalId,
      this.formAction = data.formAction
  }

  // data
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() numNights: number;
  @Input() shortTermRentalId: number;
  rateDetailLosList: any;
  rateDetailLosRows = [];

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAction: string;
  formLabels = [];
  formReadOnly = false;
  formAlert: string;
  formTitle: string;
  searchForm: any;
  scrollingColumns: any[] = [];
  frozenColumns: any[] = [];
  currentSearchForm: any;


  ngOnInit(): void
  {
    this.searchForm = {};
    let selectedShortTermRentalIds = [];
    selectedShortTermRentalIds.push(this.shortTermRentalId);
    this.searchForm.shortTermRentalIdList = selectedShortTermRentalIds;
    this.searchForm.startDate = this.startDate;
    this.searchForm.endDate = this.endDate;
    this.searchForm.numNights = this.numNights;
    if (
      this.shortTermRentalId ||
      this.searchForm.startDate ||
      this.searchForm.endDate ||
      this.searchForm.numNights)
    {
      console.log('search ' + this.searchForm);

      this.getLosRate(this.searchForm);
    }
  }


  buildColumns()
  {

    this.frozenColumns = [
      { field: 'checkInDate', header: 'CheckIn' },
    ];

    // clear between queries
    this.scrollingColumns = [];
    let processingDate = new Date(this.startDate);

    // unfrozen scrollingColumns - the rateDetailLosList will have varying lengths so just go out 30 days
    for (let index = 0; index < 32; index++)
    {
      this.scrollingColumns.push({
        field: index, header: index + 1
      });
      processingDate.setDate(processingDate.getDate() + 1);
    }
  }

  buildRows()
  {
    for (let e = 0; e < this.rateDetailLosList.length; e++)
    {
      // clear between queries
      let rateRow: any = {};

      // for each advertisedRate row in the advertisedRate list
      for (let index = 0; index < this.rateDetailLosList[e].length; index++)
      {
        rateRow[index] = this.rateDetailLosList[e][index];
      }
      rateRow.checkInDate = new DatePipe('en-US').transform(this.rateDetailLosList[e][0].checkInDate, 'MMM d');

      this.rateDetailLosRows.push(rateRow);
    }
    console.log(this.rateDetailLosRows);
    console.log(this.rateDetailLosRows.length);
  }


  getPriceFontColor(rateDetailLos: any)
  {
    if (rateDetailLos)
    {
      if (rateDetailLos.activeRate > rateDetailLos.defaultRate)
      {
        return 'red';
      }
      if (rateDetailLos.activeRate < rateDetailLos.defaultRate)
      {
        return 'green';
      }
      else
      {
        return 'black';
      }
    }
  }
  getOccupiedBackgroundColor(rateDetailLos: any, fieldName: any)
  {
    if (rateDetailLos && fieldName !== 'checkInDate')
    {
      if (rateDetailLos)
      {
        return '#ddfada';
      }
      else
      {
        return 'lightgrey';
      }
    }
  }

  onSearchSubmit(searchForm)
  {
    // kill the old transformation
    this.rateDetailLosRows = [];

    // store the search
    this.currentSearchForm = searchForm;
    this.getLosRate(searchForm);
  }

  // https://stackoverflow.com/questions/59878134/primeng-table-filtering-and-sorting-on-each-column-doesnt-work
  // everytime you click in filter it just resorts.
  clickOnFilter(event: Event)
  {
    event.stopPropagation();
  }

  /*********
      * onOpenRateBucketDetailEdit
      *
      */
  onOpenRateBucketDetailEdit(rateBucketDetailId: number)
  {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      rateBucketDetailId: rateBucketDetailId,
      title: 'Edit RateBucketDetail',
      formAction: 'edit'
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(RateBucketDetailFormComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data =>
      {
        console.log('Dialog output:', data);

        // TODO: if we update from the LOS dialog we launched from the OccupancySummary view we need to update the rows in the occupancySummary view!

        // close the dialogBox
        dialogRef.close();
      });
  }

  getLosRate(searchForm)
  {
    try
    {
      this.formLoading = true;
      this.rateManagerService.getLosRates(searchForm)
        .subscribe(
          res =>
          {
            console.log('getLosRate SUCCESS: ' + JSON.stringify(res.data.rateDetailLosList));
            this.rateDetailLosList = res.data.rateDetailLosList;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
            this.buildColumns();
            this.buildRows();
          },
          err =>
          {
            console.log('getLosRate FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error)
    {
      this.alertService.error(error);
    }
  }
}
